import type { WorkflowCase } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'
import { WorkflowCaseStatus } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'

/**
 * ケースが read-only (サブステップ操作・完了操作・遷移先関連画面〈WorkflowBackBar
 * のある画面〉での編集がすべて不可) か判定するヘルパー (spec AC-10、
 * workflow-delete-transition design §2/§5)。
 *
 * 完了済み (COMPLETE) または削除済み (DELETED、不可逆) のいずれかで read-only に
 * なる。旧来の completedAt 基準 (= `completedAt !== undefined`) では、
 * completedAt を立てない状態を見逃す (過去のブロッキング指摘: DemandForecastDaily /
 * WorkflowCaseDetail が個別に旧基準を持っていたための under-build)。
 *
 * アプリ横断 (`src/models/`) に置くのは WorkflowCaseDetail・DemandForecastDaily
 * 等、複数ページが同じ `WorkflowCase` (BFF proto) の read-only 判定を必要とする
 * ため（page-local model の複製を避ける）。
 */
export function isWorkflowCaseReadonly(
  wfCase: Pick<WorkflowCase, 'status'>,
): boolean {
  return (
    wfCase.status === WorkflowCaseStatus.COMPLETE ||
    wfCase.status === WorkflowCaseStatus.DELETED
  )
}

/**
 * 需要想定(日次編集)画面専用の read-only 判定ヘルパー（spec AC-DFC-007、
 * demand-fix-readonly-trigger design）。
 *
 * `isWorkflowCaseReadonly`（WF 全体完了/削除トリガー、AC-WFW-014 の他遷移先 gate）
 * に、`demand_step_confirmed`（本 case に business-confirmed ConfirmRecord が
 * 存在するか、backend 算出の derived field）を OR する。需要想定 step が確定
 * されたタイミング以降、後続 step / WF 全体完了を待たず読み取り専用になる
 * ("確定タイミング" 基準)。
 *
 * `demand_step_confirmed` が未 set（`undefined`）の場合は false 扱い
 * （= editable）とする — proto optional 未 set は「判定不能」であり、
 * ListWorkflowCases 起点で未 populate の時に誤って lock しない既存の
 * fallback 挙動を保つ（GetWorkflowCase 経路では常に populate される）。
 */
export function isDemandForecastReadonly(wfCase: WorkflowCase): boolean {
  return isWorkflowCaseReadonly(wfCase) || wfCase.demandStepConfirmed === true
}
